import { render, staticRenderFns } from "./AppointmentBranchList.vue?vue&type=template&id=311fa3b8"
import script from "./AppointmentBranchList.vue?vue&type=script&lang=ts"
export * from "./AppointmentBranchList.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentBranchList.vue?vue&type=style&index=0&id=311fa3b8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports